import * as React       from 'react';
import { ReactNode }    from 'react';
import ReactSelect      from "react-select";
import CreatableSelect  from 'react-select/creatable';
import Utils            from "../../../Utils";
import {Type}           from "../../../InputUtils";
import ReactJson        from "react-json-view";
import NumberInput      from "./NumberInput";
import AsyncPaginate    from "react-select-async-paginate";
import './Input.css';

interface IControl {
    checked?: boolean;
    value: any,
    id: string,
    label?: string,
    elementType: any,
    elementConfig?: any,
    changed: any,
    blur?: any,
    classNameProp?: string,
    valid?: boolean,
    touched?: boolean,
    errorMsg?: string,
    shouldValidate?: boolean,
    maxLength?: string,
    onFocus?: any,
    wrapperClass?: string,
    labelExtraClass?: string,
    itemType?: any,
    customClass?: string
    styles?: any,
    required?: boolean,
    selectInitialPosition?: boolean,
}

const input: React.SFC<IControl> = ( props: IControl ) => {
    let inputElement:ReactNode     = null;
    let label: ReactNode           = null;
    let addonLeft: ReactNode       = null;
    let addonRight: ReactNode      = null;
    let validationError: ReactNode = null;
    let inputClasses: string       = '';
    let wrapperClass: string       = '';
    let labelExtraClass: string    = '';
    let classNameProp: string    = '';

    if (props.wrapperClass) {
        wrapperClass = props.wrapperClass;
    }

    if (props.labelExtraClass) {
        labelExtraClass = props.labelExtraClass;
    }

    if (props.classNameProp) {
        classNameProp = props.classNameProp;
    }

    if (props.label) {
        label = <label className={'inputLabels ' + labelExtraClass}>{props.label}</label>;
    }

    if (!props.valid && props.required) {
        validationError = <p className='errorMsg'>{props.errorMsg}</p>;
        inputClasses += ' invalid';
    }

    switch ( props.elementType ) {
        case (Type.INPUT):
            inputElement = <input
                {...props.elementConfig}
                value     = {props.value}
                id        = {props.id}
                onChange  = {props.changed}
                onBlur    = {props.blur}
                className = {`dark-input-style ${classNameProp} ${inputClasses}`}
                maxLength = {props.maxLength}
            />;
            break;
        case (Type.NUMBER):
            inputElement = <NumberInput
                {...props.elementConfig}
                value           = {props.value}
                onChange        = {props.changed}
                classNameStyle  = {`dark-input-style ${classNameProp} ${inputClasses}`}
            />;
            break;
        case (Type.TEXT_AREA):
            inputElement = <textarea
                {...props.elementConfig}
                value        = {props.value}
                id           = {props.id}
                onChange     = {props.changed}
                onBlur       = {props.blur}
                className    = {`dark-input-style input-text-area ${classNameProp} ${inputClasses}`}
            />;
            break;
        case (Type.SELECT):
            inputElement = <ReactSelect
                {...props.elementConfig}
                id                  = {props.id}
                className           = {`${classNameProp}`}
                value               = {props.value}
                onChange            = {props.changed}
                isMulti             = {props.elementConfig.isMulti}
                closeMenuOnSelect   = {props.elementConfig.closeMenuOnSelect}
                menuPlacement       = 'auto'
                isDisabled          = {props.elementConfig.readOnlyInput}
                placeholder         = {props.elementConfig.placeholder}
                isClearable         = {props.elementConfig.isClearable}
                isSearchable        = {true}
                noOptionsMessage    = {() => props.elementConfig.noOptionsMessage}
                styles              = {Utils.getReactSelectNewDesign(props.selectInitialPosition ? props.selectInitialPosition : false)}
                theme               ={theme => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#5f8c90',
                                            primary: '#34585b',
                                            primary50: '#5f8c90'
                                        },
                                    })}
                // menuIsOpen = {true}
            />;
            break;
        case (Type.CREATABLE_SELECT):
            inputElement = <CreatableSelect
                {...props.elementConfig}
                id                  = {props.id}
                className           = {`${classNameProp}`}
                value               = {props.value}
                onChange            = {props.changed}
                isMulti             = {props.elementConfig.isMulti}
                closeMenuOnSelect   = {props.elementConfig.closeMenuOnSelect}
                menuPlacement       = 'auto'
                isDisabled          = {props.elementConfig.readOnlyInput}
                placeholder         = {props.elementConfig.placeholder}
                isClearable         = {props.elementConfig.isClearable}
                isSearchable        = {true}
                noOptionsMessage    = {() => props.elementConfig.noOptionsMessage}
                styles              = {Utils.getReactSelectNewDesign(props.selectInitialPosition ? props.selectInitialPosition : false)}
                theme               = {theme => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#5f8c90',
                                            primary: '#34585b',
                                            primary50: '#5f8c90'
                                        },
                                    })}
                // menuIsOpen = {true}
            />;
            break;
        case (Type.ASYNC_PAGINATE):
            inputElement = <AsyncPaginate
                {...props.elementConfig}
                id                  = {props.id}
                className           = {`${classNameProp}`}
                value               = {props.value}
                onChange            = {props.changed}
                isMulti             = {props.elementConfig.isMulti}
                closeMenuOnSelect   = {props.elementConfig.closeMenuOnSelect}
                menuPlacement       = 'auto'
                isDisabled          = {props.elementConfig.readOnlyInput}
                placeholder         = {props.elementConfig.placeholder}
                isClearable         = {props.elementConfig.isClearable}
                isSearchable        = {true}
                noOptionsMessage    = {() => props.elementConfig.noOptionsMessage}
                styles              = {Utils.getReactSelectNewDesign(props.selectInitialPosition ? props.selectInitialPosition : false)}
                theme               = {theme => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary25: '#5f8c90',
                        primary: '#34585b',
                        primary50: '#5f8c90'
                    },
                })}
                // menuIsOpen = {true}
            />;
            break;
        case (Type.INPUT_SWITCH):
            inputElement = <div className="switchContainer">
                <input
                    {...props.elementConfig}
                    id        = {props.id}
                    type      = "checkbox"
                    value     = {props.value}
                    checked   = {props.value === "true"}
                    onChange  = {props.changed}
                    className = {`${classNameProp}`}
                />
                <label htmlFor={props.id} />
            </div>
            break;
        case (Type.JSON_CONTAINER):
            inputElement = <ReactJson
                {...props.elementConfig}
                style={{background: '#2D3436', minHeight: '100%'}}
                enableClipboard={false}
                theme={'tomorrow'}
                displayDataTypes={false}
            />
            break;
        default:
            inputElement = <input
                {...props.elementConfig}
                value     = {props.value}
                id        = {props.id}
                onChange  = {props.changed}
                onBlur    = {props.blur}
                className = {`dark-input-style ${props.classNameProp} ${inputClasses}`}
                maxLength = {props.maxLength}
            />;
    }

    return (
        <React.Fragment>
            <div className={`input-group-container ${wrapperClass}`}>
                {label}
                {addonLeft}
                {inputElement}
                {addonRight}
                {validationError}
            </div>
        </React.Fragment>
    );

};

export default input;



// WEBPACK FOOTER //
// ./app/components/common/Input/Input.tsx